import React from "react";

function LineParam({title, value, status, unit, bold}) {

    return (
        <div className="line-param">
            <p className={`mb-0 title-param${bold ? " fw-bold" : ""}`}>
                <span className="bg-white">{title}</span>
            </p>
            <div className="values">
                <p className={`mb-0 value-param ${status}${bold ? " fw-bold" : ""}`}><span className="bg-white">{value}</span>
                    <span className="ms-1 text-dark fw-normal">
                        <span className="bg-white">{unit}</span>
                    </span>
                </p>
            </div>
            <div className="dotter">
                ..................................................................................................
            </div>
        </div>
    );
}

export default LineParam;